module.exports = __webpack_public_path__ + "static/whereSC-65cd482f78d30f237fa00dedc1c95481.jpg";